/// <reference path="../../../typings/tsd.d.ts" /> 
/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class InnerFormSection implements IDirective {

        public link($scope: directives.IFormSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) { }

        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            showSlider: "=",
            formSection: "=",
            process: "=",
            isReadOnly: "=",
            fieldBlurred: "=",
            processConfigurationId: "=",
            processConfiguration: "=",
            formData: "=",
            formDataId: "=",
            formId: "=",
            processId: "=",
            save: "=",
            step: "=",
            parentFormId: "=",
            form: "="
        };
        public templateUrl = './app/views/directives/inputForm/innerFormSection.html';
    }
}

warsApp.registerDirective('InnerFormSection', []);